<div class="d-flex flex-row justify-content-center align-items-center"
     [style.height]="logoSize">
  <div *ngIf="showLogo" id="sk-logo" class="sk-logo-element" [style.height]="logoSize" [style.width]="logoSize"></div>
  <div *ngIf="showFont" id="sk-font" class="sk-logo-element" [style.height]="'calc(' + logoSize + ' / 2)'" [style.width]="'calc(' + logoSize + ' * 5)'"></div>
</div>
